$('#teacherOrStaff').selectize();
$('#tool').selectize();
